import React, { useState, useEffect } from "react";
import DataTable from 'react-data-table-component';
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

import { api_crud_route, api_crud_base, /*api_list_route,*/ endpoints } from './Config';

import { reqGET, reqDELETE } from '../../../Utils';
import { getTokenInfo } from '../../../UseToken';
import UseSidebar from '../../../UseSidebar';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

export default function List() {

    const [data, setData] = useState([])
    const [/*data_2*/, setData_2] = useState([])
    const [isloading, setLoading] = useState(true)

	const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation();
    const [, set_sidebar] = useState([])
    const [permissions, set_permissions] = useState({})

    const get_parent_depth = (parent, prefix) => {
        let aux = data.filter(v => v.id === parent)
        if(aux.length > 0) {
            prefix += '-'
            return get_parent_depth(aux[0].info.parent, prefix)
        }
        else {
            return prefix
        }
    }

    let get_permissions = (e, sidebar) => {
        let handleSingleCheck = (e, sidebar) => {
            const name = e;

            let ver_submenu = (node) => {
                if (node.submenu.length !== 0) {

                    node.submenu.forEach(subitem => {

                        if (subitem.path === name) {
                            set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                        }
                        else {
                            ver_submenu(subitem)
                        }

                    })
                }
            }

            sidebar.forEach(node => {
                if(node.path === name && 0) {
                    set_permissions({ edit: node.edit, view: true, remove: node.remove })
                } else
                    ver_submenu(node)
            })
        }

        handleSingleCheck(e, sidebar)
    }

    
    useEffect(() => {

        const order_menu = (parent, array, array2) => {
            let array_aux = array.filter(v => v.info.parent === parent)
            array_aux.forEach(v => {
                array2.push(v)
                order_menu(v.id, array, array2)
            })
        }

        let fetchApi = async () => {
            set_lang(localStorage.getItem('lang'))
    
            return await reqGET(`${api_crud_base}/web/content/type/${getTokenInfo().companycode}/content`)
                .then(res => {
                    let array_aux = []
                    order_menu('0', res.data, array_aux)
                    setData(array_aux)
    
                    setData_2(array_aux)
                    setLoading(false)
                })
                .catch(() => 404
                    //  TODO: ENVIAR PÁGINA 404
                    //alert(error)); 
                )
        }

        fetchApi()  
        
        UseSidebar().getSidebar(getTokenInfo().profile)
            .then(v => {
                get_permissions(pathname, v)
                set_sidebar(v)
                setLoading(false)
            }); 
    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route, { id: id })
					.then(res => {
						//props.history.push(endpoints.list);
					})
					.catch(error => console.log(error))
			}
		})

    }

    const columns = [
        {
            name: language[lang].table_title,
            selector: 'content[0].title',
            cell: row => <div>{row.content[0].title}</div>,
            width: '50%',
            minWidth: '30% !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].table_date,
            selector: 'info.date.creation',
            cell: row => {
                let date = new Date(row.info.date.creation); 
                
                return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
            },
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].table_date_published,
            selector: 'info.date.published',
            cell: row => {
                if(row.info.date.published !== '') {
                    let date = new Date(row.info.date.published); 
                    
                    return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
                }
                else {
                    return ''
                }
            },
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].table_state,
            selector: 'title',
            cell: row => {
                let hoje = new Date();
                //let date = new Date(row.info.date.creation); 
                
                let status = 0
                if(row.info.date.published !== undefined && row.info.date.published !== '') {
                    var date_p = new Date(row.info.date.published);

                    status = 1
                    if(hoje >= date_p) 
                        status = 2
                }
                if(row.info.date.avaiable !== undefined && row.info.date.avaiable !== '') {
                    var date_a = new Date(row.info.date.avaiable);

                    if(hoje > date_a) 
                        status = 3
                }
                
                return (
                    <span className={status === 2 ? "badge rounded-pill fw-normal bg-success" : (status === 1 ? "badge rounded-pill fw-normal bg-info" : "badge rounded-pill fw-normal bg-primary")}>
                        {status === 3 ? language[lang].archive : (status === 2 ? language[lang].published : (status === 1 ? language[lang].schedule_to : language[lang].draft))}
                    </span>
                )
            },
            width: '10%',
            minWidth: '82px !important',
            sortable: false,
            center: true,
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '20%',
            minWidth: '100px !important',
            cell: row =>
                <span>
                    <Link className="button button-update button-view d-none" to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>

                    {
                    permissions.edit ?
                        <Link className={permissions.edit ? "button button-update" : "d-none" } to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }} style={{ display: '' }} replace>
                            <i className="bi bi-pencil"></i>
                        </Link>
                    :
                        null
                    }

                    {
                    permissions.remove ?
                        <button className={permissions.remove ? "button button-delete d-none" : "d-none" } onClick={() => apagar(row['id'])}>
                            <i className="bi bi-trash"></i>
                        </button>
                    :
                        null
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    return (isloading ?
        
        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <h2 className="dash-title">{language[lang].content_list}</h2>
                <p>{language[lang].content} / {language[lang].content_list}</p>
            </div>
        
            <div className={`dash-cards body`}>
                <div className="container">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">
                        
                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header text-end mb-5">
                                        <Link className="btn btn-sm btn-secondary rounded-0 multi-item" to={{ pathname: endpoints.regist }}  >
                                            <span>{language[lang].add_new}</span>
                                        </Link>
                                    </div>
                                    <div className="table-body">

                                        <DataTable
                                            columns={columns}
                                            data={data}
                                            noDataComponent={language[lang].table_empty}
                                            noHeader
                                            pagination
                                            exportHeaders
                                            paginationComponentOptions={defaultComponentOptions}
                                            paginationPerPage={25}
                                            paginationRowsPerPageOptions={[25, 50, 100]}
                                        />
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card mb-5 mb-xl-8 d-none">
                        <div className="card-body">
                            <div className="pb-10 ">
                                <div className="div-table">
                                    <div className="table-body">

										<table className="table align-middle table-row-dashed fs-6 gy-5" id="kt_table_users">
											<thead>
												<tr className="text-start text-muted fw-bolder fs-7 text-uppercase gs-0">
													<th className="min-w-250px">{language[lang].table_title}</th>
													<th className="min-w-125px d-none">{language[lang].table_parent}</th>
													<th className="text-center min-w-125px">{language[lang].table_date}</th>
													<th className="text-center min-w-100px">{language[lang].table_state}</th>
													<th className="text-end min-w-100px">{language[lang].table_actions}</th>
												</tr>
											</thead>
											<tbody className="text-gray-600 fw-bold">
                                                {
                                                data.map((element, key) => {
                                                    var hoje = new Date();
                                                    var date = new Date(element.info.date.creation); 
                                                    
                                                    let status = 0
                                                    if(element.info.date.published !== undefined && element.info.date.published !== '') {
                                                        var date_p = new Date(element.info.date.published);

                                                        status = 1
                                                        if(hoje >= date_p) 
                                                            status = 2
                                                    }

                                                    return(
                                                        <tr key={key}>
                                                            <td>{get_parent_depth(element.info.parent, '')} {element.info.name}</td>
                                                            <td className="d-none">{element.info.parent}</td>
                                                            <td className="text-center">{date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()}</td>
                                                            <td className="text-center">
                                                                <span className={status === 2 ? "badge rounded-pill bg-success" : (status === 1 ? "badge rounded-pill bg-info" : "badge rounded-pill bg-primary")}>
                                                                    {status === 2 ? language[lang].published : (status === 1 ? language[lang].schedule_to : language[lang].draft)}
                                                                </span>
                                                            </td>
                                                            <td className="text-end">
                                                                <Link className="button button-update button-view" to={{ pathname: endpoints.view, state: { item: element, operation: 'view' } }} replace>
                                                                    <i className="bi bi-eye"></i>
                                                                </Link>

                                                                {
                                                                permissions.edit ?
                                                                    <Link className={permissions.edit ? "button button-update" : "d-none" } to={{ pathname: endpoints.regist, state: { item: element, operation: 'edit' } }} replace>
                                                                        <i className="bi bi-pencil"></i>
                                                                    </Link>
                                                                :
                                                                    null
                                                                }

                                                                {
                                                                permissions.remove ?
                                                                    <button className={permissions.remove ? "button button-delete d-none" : "d-none" } onClick={() => apagar(element.id)} >
                                                                        <i className="bi bi-trash"></i>
                                                                    </button>
                                                                :
                                                                    null
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                }) 
                                                }												
											</tbody>
										</table>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}